import LazyLoading from './lib/lazy-loading'
import Menu from './template-parts/common/menu'
import Pagination from './template-parts/components/pagination'
import ContactForm from './template-parts/common/contact-form'
import ModContactForm from './template-parts/common/mod-contact-form'
import RentaForm from './template-parts/common/renta-form'
import Hero from './template-parts/common/hero'
import Footer from './template-parts/common/footer'
import GeBl11MobileAccordion from './template-parts/sections/grado-bl11-mobile-accordion'
import DistribFaqsMobileAccordion from './template-parts/sections/distrib-faqs-mobile-accordion'
import GeBl11Tabs from './template-parts/sections/grado_bl11-tabs'
import Header from './template-parts/common/header.js'

export default class ModulesLoader {
  constructor (el = document) {
    this.el = el
  }

  loadModules () {
    window.header = new Header()
    window.lazyLoading = new LazyLoading()
    window.hero = new Hero()
    window.footer = new Footer()
    window.contactForm = new ContactForm()
    window.modcontactForm = new ModContactForm()
    window.rentaForm = new RentaForm()
    window.pagination = new Pagination()
    window.menu = new Menu()
    window.grado_esp_bloque11 = new GeBl11MobileAccordion()
    window.distrib_faqs = new DistribFaqsMobileAccordion()
    window.grado_esp_bloque11 = new GeBl11Tabs()
  }
}
